export default {
    price(number: number, fraction: number = 0): string {
        return new Intl.NumberFormat(
            'ru-Ru',
            {
                minimumFractionDigits: fraction,
                maximumFractionDigits: fraction
            }
        ).format(number);
    }
}
